import React, {} from 'react'
import '../css/contact.css'

import Maps from './Maps';

export default function Contact() {

  return (
    <>
    <section className='contact' id='contact'>
        <div className='container'>
            <div className='contact-container'>
                <div className='contact-content'>
                    <div className='info-contact-box'>
                        <h2>Get In Touch</h2>
                        <p> Whether you have questions, need assistance, or just want to share your thoughts, feel free to reach out to us. We're here to help and ensure you have the best experience possible.</p>
                        <div className='contact-container-box'>
                            <div className='contact-content-box'>
                                <div className='contact-icon'><i class="fi fi-rs-phone-call"></i></div>
                                <div className='contact-box'>
                                    <div className='contact-title'>Phone</div>

                                    <div className='contact-info'>+52 612 123 66 00 Ext. 1340. </div>
                                </div>
                            </div>
                            <div className='contact-content-box'>
                                <div className='contact-icon'><i class="fi fi-rs-envelope"></i></div>
                                <div className='contact-box'>
                                    <div className='contact-title'>Email</div>
                                    <div className='contact-info'>contact@comatur.com</div>
                                </div>
                            </div>
                            <div className='contact-content-box'>
                                <div className='contact-icon'><i class="fi fi-rs-marker"></i></div>
                                <div className='contact-box'>
                                    <div className='contact-title'>Adress</div>
                                    <div className='contact-info'>Ignacio Allende No. 1025 Col. Centro, C.P. 23000 </div>
                                </div>
                            </div>
                                           
                        </div>
                    </div>
                    
                </div>
                {/*<div className='contact-content'>
                <div class="formulario">
               
                    <Maps />                            
                                
                </div>
                </div>   */}             
            </div>

        </div>
    </section>
    </>
  )
}
